import "../../css/settings/languages.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function Languages({ theme }) {
  const { t, i18n } = useTranslation();

  const [languagesCookie, setlanguagesCookie] = useState("");

  const cookies = document.cookie.split(";");
  useEffect(() => {
    document.title = t("Hiket, Lnaguages");
    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");

      if (key.trim() === "language") {
        setlanguagesCookie(value.trim());
        i18n.changeLanguage(value.trim());
      }
    }
  }, [i18n]);

  const setLnaguage = (lang) => {
    document.cookie = `language=${lang}; max-age=32000000; path=/;`;
    setlanguagesCookie(lang);
    i18n.changeLanguage(lang);
    document.documentElement.dir = lang === "fa" ? "rtl" : "ltr";
  };

  const LnaguagesArray = [
    { code: "en", name: t("English") },
    { code: "fa", name: t("Persian") },
    { code: "fr", name: t("France") },
  ];

  const sortedLanguages = [...LnaguagesArray].sort((a, b) => {
    if (a.code === languagesCookie) return -1;
    if (b.code === languagesCookie) return 1;
    return 0;
  });

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>{t('Languages')}</div>
      <div className="contentDiv padding12 gap12">
        <div className="kfmeoo3lv">{t("Selecting a language ...")}</div>
        {sortedLanguages.map((lang) =>
          lang.code === languagesCookie ? (
            <button
              className={`big_button not_padding ${theme}`}
              onClick={() => {
                setLnaguage(lang.code);
              }}
            >
              <div>{lang.name}</div>
              <div className="center_div"></div>
              <img src="/icons/selected.png"></img>
            </button>
          ) : (
            <button
              className={`big_button not_padding ${theme}`}
              onClick={() => {
                setLnaguage(lang.code);
              }}
            >
              <div>{lang.name}</div>
            </button>
          ),
        )}
      </div>
    </div>
  );
}

export default Languages;
